<template>
    <section>
        <v-btn @click="OpenRatingModel">Add Course Rating</v-btn>
        <app-review-list></app-review-list>
        <app-review :dialog='Dialog' @close='CloseRatingModel'></app-review>
    </section>
</template>
<script>
import appReviewList from '../views/tables/ReviewListTable'
import appReview     from '../views/dialogs/AddReview'
export default {
    components:{
        appReviewList,
        appReview
    },
    data(){
        return {
            Dialog : false
        }
    },
    methods:{
        OpenRatingModel(){
            this.Dialog = true
        },
        CloseRatingModel(){
            this.Dialog = false
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>